module.exports = {
    "id": "mango",
    "title": "mango",
    "image": "provision/parts/mango/mango.png",
    "info": [
      {
        "text": "Add a mango to your project",
        "image": "provision/parts/mango/mango.png"
      }
    ],
    "exposedVariables": [
    ],
    "codeImage": "provision/parts/mango/mango.png"
  };